// ============================================
// Path: /frontend/src/pages/LoginPage.jsx
// Purpose: Login page wrapper
// ============================================

import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { LoginForm } from '../components/auth/LoginForm';

export default function LoginPage() {
  return (
    <div className="flex flex-col min-h-screen bg-muted/40">
      <Header />
      <main className="flex-grow flex items-center justify-center">
        <LoginForm />
      </main>
      <Footer />
    </div>
  );
}